"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var react_1 = __importStar(require("react"));
var types_1 = require("../../../types");
var SetLimits_1 = require("../../SetLimits");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var EmptyCard = function (_a) {
    var title = _a.title, description = _a.description, type = _a.type;
    var t = (0, next_intl_1.useTranslations)('translation');
    var _b = (0, react_1.useState)(null), limitToSet = _b[0], setLimitToSt = _b[1];
    var isShowSetGameLimit = (0, react_1.useMemo)(function () {
        return (limitToSet === types_1.LimitType.DEPOSIT ||
            limitToSet === types_1.LimitType.LOSS ||
            limitToSet === types_1.LimitType.BET);
    }, [limitToSet]);
    var isShowSetSessionLimit = (0, react_1.useMemo)(function () {
        return limitToSet === types_1.LimitType.SESSION;
    }, [limitToSet]);
    var isShowSetCoolingOffLimit = (0, react_1.useMemo)(function () {
        return limitToSet === types_1.LimitType.COOLING_OFF;
    }, [limitToSet]);
    var openSetLimit = (0, react_1.useCallback)(function () {
        setLimitToSt(type);
    }, [setLimitToSt, type]);
    var closeSetLimit = (0, react_1.useCallback)(function () {
        setLimitToSt(null);
    }, [setLimitToSt]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, title),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.description }, description),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.notSet }, t('notSet')),
            react_1.default.createElement(ui_components_1.FixedButton, { color: "gradient", text: "upper", onClick: openSetLimit, width: "100%", maxWidth: "100%" }, t('setNow'))),
        isShowSetGameLimit && (react_1.default.createElement(SetLimits_1.SetGameLimit, { type: type, onClose: closeSetLimit })),
        isShowSetSessionLimit && react_1.default.createElement(SetLimits_1.SetSessionLimit, { onClose: closeSetLimit }),
        isShowSetCoolingOffLimit && (react_1.default.createElement(SetLimits_1.SetCoolingOffLimit, { onClose: closeSetLimit }))));
};
exports.default = EmptyCard;
